<template>
    <div class="pitchin-page">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('融资申请') }}</div>
        </div>
        <div style="width: 100%;height: fit-content;padding:60px 15px 15px 15px;">

            <!-- 主标题区域 -->
            <section class="title-section">
                <h1 class="main-title">
                    <span class="black-text">{{ $t('locn_t1') }}</span>
                </h1>
                <p class="desc-text">
                    {{ $t('locn_t2') }}
                </p>
                <div class="btn-group">
                    <button class="btn-red" @click="handleApply">{{ $t('立即申请') }}</button>
                    <button class="btn-red" @click="handleMine">{{ $t('我的融资') }}</button>
                </div>
            </section>

            <!-- 插画区域 -->
            <div class="illustration-box">
                <img src="@/assets/images/logo/why-bg.png" alt="">
            </div>

            <!-- 数据统计卡片 -->
            <section class="stat-row">
                <div class="stat-card">
                    <h2 class="stat-num">{{ $t('locn_t3', { num: 3.5 }) }}</br>{{ $t('以上') }}</h2>
                    <p class="stat-desc">{{ $t('提高') }}</p>
                    <p class="box">{{ $t('总计') }}</p>
                </div>
                <div class="stat-card">
                    <h2 class="stat-num">{{ $t('全球超过') }}</br>18,000+</h2>
                    <p class="stat-desc">{{ $t('投资者') }}</p>
                    <p class="box">{{ $t('个人和机构组成') }}</p>
                </div>
            </section>

            <!-- 资质介绍卡片 -->
            <div style="width: 100%;height: 1px;background: #eee;margin-bottom: 40px;"></div>

            <!-- 人人可投资板块 -->
            <section class="invest-advantage">
                <h2 class="block-title">{{ $t('locn_t4') }}</h2>
                <p class="block-desc">{{ $t('locn_t5') }}</p>

                <div class="advantage-list">
                    <div class="adv-item">
                        <div class="icon fire-icon">
                            <img src="@/assets/images/logo/1.svg" alt="">
                        </div>
                        <h2 class="rmo-title">{{ $t('locn_t6') }}</h2>
                        <p class="rmo-desc">{{ $t('locn_t7') }}</p>
                    </div>
                    <div class="adv-item">
                        <div class="icon money-icon">
                            <img src="@/assets/images/logo/2.svg" alt="">
                        </div>
                        <h2 class="rmo-title">{{ $t('locn_t8') }}</h2>
                        <p class="rmo-desc">{{ $t('locn_t9') }}</p>
                    </div>
                    <div class="adv-item">
                        <div class="icon pie-icon">
                            <img src="@/assets/images/logo/33.svg" alt="">
                        </div>
                        <h2 class="rmo-title">{{ $t('locn_t10') }}</h2>
                        <p class="rmo-desc">{{ $t('locn_t11') }}</p>
                    </div>
                </div>

                <div class="tip-text">
                    <img src="@/assets/images/logo/bg.svg" alt="">
                    <span class="red-txt">{{ $t('助力打造下一批成功故事') }}</span>
                    <span class="green-tip">{{ $t('locn_t13') }}</span>
                </div>
            </section>

            <!-- 两分钟开户板块 -->
            <section class="fast-invest-block">
                <h2 class="block-title">{{ $t('急速审核发放') }}</h2>
                <div class="fast-list">
                    <div class="fast-item">
                        <div class="fast-icon hand-icon">
                            <img src="@/assets/images/logo/ok.svg" alt="">
                        </div>
                        <div class="fast-content">
                            <h3>{{ $t('手续费', { num: 0 }) }}</h3>
                            <p>{{ $t('融资全程') }}</p>
                        </div>
                    </div>
                    <div class="fast-item">
                        <div class="fast-icon thumb-icon">
                            <img src="@/assets/images/logo/yes.svg" alt="">
                        </div>
                        <div class="fast-content">
                            <h3>{{ $t('严选项目') }}</h3>
                            <p>{{ $t('yxxx') }}</p>
                        </div>
                    </div>
                    <div class="fast-item">
                        <div class="fast-icon crowd-icon">
                            <img src="@/assets/images/logo/a.svg" alt="">
                        </div>
                        <div class="fast-content">
                            <h3>{{ $t('品类多元覆盖') }}</h3>
                            <p>{{ $t('pldy') }}</p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 底部成功案例板块 -->
            <section class="case-block">
                <div class="case-grid">
                    <div class="case-card">
                        <img src="@/assets/images/logo/Barbie.png" alt="">
                        <div class="t">
                            《Barbie》
                        </div>
                        <div class="ts">
                            {{ $t('case1_subtitle') }}
                        </div>
                        <div class="f-box">
                            <div class="box">
                                {{ $t('case1_desc') }}
                            </div>
                            <div class="box2">
                                <div>{{ $t('investors') }}</div>
                                <div>{{ $t('case1_count') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="case-card">
                        <img src="@/assets/images/logo/HarruPotter.jpg" alt="">
                        <div class="t">
                            《Harry Potter》
                        </div>
                        <div class="ts">
                            {{ $t('case2_subtitle') }}
                        </div>
                        <div class="f-box">
                            <div class="box">
                                {{ $t('case2_desc') }}
                            </div>
                            <div class="box2">
                                <div>{{ $t('investors') }}</div>
                                <div>{{ $t('case2_count') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="case-card">
                        <img src="@/assets/images/logo/aquaman.jpg" alt="">
                        <div class="t">
                            《Aquaman》
                        </div>
                        <div class="ts">
                            {{ $t('case3_subtitle') }}
                        </div>
                        <div class="f-box">
                            <div class="box">
                                {{ $t('case3_desc') }}
                            </div>
                            <div class="box2">
                                <div>{{ $t('investors') }}</div>
                                <div>{{ $t('case3_count') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="case-card">
                        <img src="@/assets/images/logo/Thedarkkinght.jpg" alt="">
                        <div class="t">
                            《The Dark Knight》
                        </div>
                        <div class="ts">
                            {{ $t('case4_subtitle') }}
                        </div>
                        <div class="f-box">
                            <div class="box">
                                {{ $t('case4_desc') }}
                            </div>
                            <div class="box2">
                                <div>{{ $t('investors') }}</div>
                                <div>{{ $t('case4_count') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div style="height: 40px;"></div>
        <div class="invest-qualify-box">
            <h1 class="main-title">{{ $t('成为早期投资者既简单又免费') }}</h1>
            <div class="require-wrap">
                <h3 class="sub-title">{{ $t('最低要求') }}:</h3>
                <ul class="require-list">
                    <li class="list-item">{{ $t('18岁以上') }}</li>
                    <li class="list-item">{{ $t('有效身份证或证件') }}</li>
                    <li class="list-item">{{ $t('wcrw') }}</li>
                </ul>
            </div>
            <button class="action-btn" @click="handleApply">{{ $t('立即融资') }}</button>
            <div style="height: 50px;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PitchInPage",
    data() {
        return {};
    },
    mounted() { },
    methods: {
        handleJump(path) {
            if (window.plus) {
                plus.runtime.openURL(encodeURI(path + '?wt=app'))
                return
            } else {
                window.open(path)
            }
        },
        handleApply() {
            this.$router.push('/loanApply')
        },
        handleMine() {
            this.$router.push('/loanMy')
        }
    },
};
</script>

<style lang="less" scoped>
.pitchin-page {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    min-height: 100vh;
    background: #ffffff;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", sans-serif;
}

.red_top_bg {
    border-bottom: 1px solid #F1F1F1;
    height: 50px;
    position: relative;
    position: fixed;
    top: 0px;

    .back_left {
        margin: 0px;
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
    }
}

/* 顶部header */
.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;

    .logo-box {
        position: relative;
        width: 120px;
        height: 50px;

        .logo-red-border {
            width: 100%;
            height: 100%;
            border: 4px solid #d81e05;
            border-radius: 8px;
            position: absolute;
            top: 0;
            left: 0;

            &::after {
                content: "";
                position: absolute;
                top: 4px;
                left: 4px;
                right: 4px;
                height: 8px;
                background: #008833;
            }
        }

        .logo-text {
            position: relative;
            z-index: 2;
            line-height: 50px;
            padding-left: 10px;
            color: #d81e05;
            font-weight: bold;
            font-size: 24px;
        }
    }

    .menu-icon {
        font-size: 32px;
        color: #333;
    }
}

/* 主标题区 */
.title-section {
    .main-title {
        font-size: 22px;
        line-height: 1.4;
        margin: 0 0 20px 0;

        .black-text {
            color: #222;
            font-weight: bold;
        }
    }

    .desc-text {
        font-size: 15px;
        color: #666;
        line-height: 1.5;
        margin-bottom: 30px;
    }

    .btn-group {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 30px;

        .btn-red {
            flex: 1;
            background: #BF2026;
            color: #fff;
            border: none;
            border-radius: 6px;
            padding: 16px 4px;
            font-size: 16px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
        }

        .link-text {
            color: #d81e05;
            font-size: 28px;
        }
    }
}

/* 插画占位 */
.illustration-box {
    width: 100%;
    height: 300px;
    margin: 40px 0;

    img {
        display: block;
        width: 100%;
        height: auto;
    }
}

/* 统计卡片行 */
.stat-row {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;

    .stat-card {
        flex: 1;
        border: 1px solid #eee;
        border-radius: 10px;
        padding: 10px 10px;

        .stat-num {
            font-size: 20px;
            margin: 0;
            line-height: 1.2;

            .stat-label {
                font-size: 36px;
            }
        }

        .stat-desc {
            font-size: 24px;
            color: #222;
            font-weight: bold;
            margin: 10px 0 0 0;
            font-size: 14px;

            small {
                font-size: 20px;
                color: #999;
            }
        }

        .box {
            font-size: 12px;
            color: #999;
            border-top: 1px solid #eee;
            padding: 10px 0px 5px 0px;
            margin-top: 15px;
        }
    }
}

/* 优势板块 */
.invest-advantage {
    margin-bottom: 60px;

    .block-title {
        font-size: 20px;
        text-align: center;
        margin: 0 0 20px 0;
    }

    .block-desc {
        text-align: center;
        font-size: 12px;
        color: #666;
        margin-bottom: 50px;
        line-height: 1.5;
    }

    .advantage-list {
        display: flex;
        flex-direction: column;
        gap: 40px;
        margin-bottom: 50px;

        .adv-item {
            text-align: center;

            .icon {
                width: 80px;
                height: 80px;
                margin: 0 auto 20px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 40px;

                img {
                    display: block;
                    width: 60px;
                    height: 60px;
                }
            }

            .fire-icon {
                background: #ffe9e9;
            }

            .money-icon {
                background: #e8f4ff;
            }

            .pie-icon {
                background: #fff8e6;
            }

            .rmo-title {
                font-size: 15px;
                margin: 0 0 12px 0;
                color: #666;
            }

            .rmo-desc {
                font-size: 12px;
                color: #666;
            }
        }
    }

    .tip-text {
        width: 100%;
        height: 300px;
        position: relative;

        img {
            display: block;
            width: 100%;
            height: 100%;
            transform: translateX(-100px);
        }

        .red-dot {
            color: #d81e05;
            font-size: 30px;
        }

        .red-txt {
            font-size: 16px;
            color: #d81e05;
            font-weight: bold;
            position: absolute;
            top: 60px;
            left: 68px;
        }

        .green-tip {
            font-size: 16px;
            color: #008833;
            position: absolute;
            bottom: 60px;
            left: 115px;
        }
    }
}

/* 两分钟开户 */
.fast-invest-block {
    margin-bottom: 60px;

    .block-title {
        font-size: 20px;
        text-align: center;
        margin: 0 0 40px 0;
    }

    .fast-list {
        display: flex;
        flex-direction: column;
        gap: 40px;

        .fast-item {
            display: flex;
            gap: 20px;
            align-items: flex-start;

            .fast-icon {
                width: 60px;
                height: 60px;
                flex-shrink: 0;
                border-radius: 8px;
                background: #f2f2f2;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 30px;

                img {
                    display: block;
                    width: 40px;
                    height: 40px;
                }
            }

            .fast-content {
                h3 {
                    font-size: 16px;
                    margin: 0 0 8px 0;
                }

                p {
                    font-size: 14px;
                    color: #666;
                    margin: 0;
                    line-height: 1.4;
                }
            }
        }
    }
}

/* 审核流程 */
.audit-block {
    background: #edf7f3;
    padding: 40px 20px;
    border-radius: 12px;
    margin-bottom: 60px;

    .block-title {
        font-size: 40px;
        margin: 0 0 20px 0;
    }

    .audit-desc {
        font-size: 24px;
        color: #444;
        line-height: 1.5;
        margin-bottom: 40px;
    }

    .audit-steps {
        display: flex;
        flex-direction: column;
        gap: 30px;

        .step-item {
            display: flex;
            gap: 20px;
            align-items: flex-start;

            .step-icon {
                width: 50px;
                height: 50px;
                flex-shrink: 0;
                background: #fff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 26px;
            }

            .step-content {
                h3 {
                    font-size: 28px;
                    margin: 0 0 8px 0;
                }

                p {
                    font-size: 22px;
                    color: #555;
                    margin: 0;
                    line-height: 1.4;
                }
            }
        }
    }
}

/* 底部案例 */
.case-block {
    .block-title {
        font-size: 20px;
        text-align: center;
        margin: 0 0 12px 0;
    }

    .case-sub {
        text-align: center;
        font-size: 14px;
        color: #666;
        margin-bottom: 40px;
    }

    .case-grid {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        grid-template-columns: 1fr 1fr;
        gap: 20px;

        .case-card {
            width: calc(50% - 10px);
            height: fit-content;
            background: #fff;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            color: #999;
            font-size: 22px;
            box-shadow: 0px 0px 6px #cccccc;
            padding: 10px;
            box-sizing: border-box;
            overflow: hidden;

            img {
                width: 60px;
                height: 60px;
                display: block;
                box-shadow: 0px 0px 6px #ccc;
                padding: 0;
                margin: 0;
            }

            .t {
                width: 100%;
                color: #000;
                font-size: 14px;
                white-space: nowrap;
                font-weight: bold;
                margin: 12px auto;
                text-align: left;
            }

            .ts {
                width: fit-content;
                font-size: 10px;
                background: #eeeeee;
                padding: 5px;
                margin-bottom: 10px;
            }

            .f-box {
                width: 100%;
                display: flex;

                .box {
                    width: 58%;
                    height: 150px;
                    overflow: hidden;
                    overflow-y: auto;
                    font-size: 12px;
                    line-height: 14px;
                    padding: 4px;
                    text-align: left;
                    word-break: break-all;
                }

                .box2 {
                    width: 42%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    font-size: 12px;
                    white-space: nowrap;
                    padding-top: 5px;

                    div:nth-child(2) {
                        color: #222;
                        margin-top: 12px;
                        font-weight: bold;
                        font-size: 14px;
                    }

                    div {
                        word-break: keep-all;

                    }
                }
            }
        }
    }
}

.invest-qualify-box {
    width: 100%;
    background-color: #0a1480;
    padding: 60px 40px;
    box-sizing: border-box;
    color: #ffffff;
}

.main-title {
    font-size: 18px;
    margin: 0 0 50px 0;
    font-weight: normal;
}

.sub-title {
    font-size: 14px;
    margin: 0 0 20px 0;
    font-weight: normal;
}

.require-list {
    list-style: none;
    padding: 0;
    margin: 0 0 50px 0;
}

.list-item {
    font-size: 14px;
    margin-bottom: 20px;
    position: relative;
    padding-left: 32px;
}

.list-item::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
}

.action-btn {
    background: transparent;
    border: 2px solid #fff;
    color: #fff;
    font-size: 15px;
    padding: 10px 18px;
    border-radius: 6px;
    cursor: pointer;
}
</style>